import Request from 'api/Request';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<{}>>;

const forgotUsername = (email: string): ReturnType => {
    return Request.post(`/authentication/request-username`, { field: email });
};
export default forgotUsername;
